<template>
    <div 
        :class="['a-p-list-item', dark ? 'a-p-list-item--dark' : '']"
        :style="customStyle"
    >
        <div 
            class="a-p-list-item__title"
            ref="title"
        >
            {{title}}
        </div>
        <div 
            class="a-p-list-item__floor"
            :style="{
                'backgroundColor': floorColor,
                height: `calc(${customStyle.lineHeight} - 0.104vw)`
            }"
        >
            {{floor}}
        </div>
        <div class="a-p-list-item__nr">
            {{nr}}
        </div>
    </div>
</template>

<script>

export default {
    name: 'APListItem',
    props: {
        title: {
            type: String,
            default: ''
        },
        dark: {
            type: Boolean,
            default: false
        },
        floor: {
            type: [Number, String],
            default: '-'
        },
        floorColor: {
            type: String,
            default: '#E66640'
        },
        nr: {
            type: [Number, String],
            default: '-'
        },
        customStyle: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>

<style lang="scss">
@import "a-p-list-item";
</style>
